/**
 * Full-document navigations made by the router. Kept in one module so the router's hand-offs to
 * documents it does not render (the intake, static surfaces, other origins) can be observed in tests,
 * where jsdom does not navigate.
 */
export function assignDocument(url: string): void {
  window.location.assign(url);
}

/** Replaces the current history entry with a document load. */
export function replaceDocument(url: string): void {
  window.location.replace(url);
}
